import React from "react";
import { motion } from "framer-motion";
import { PROCESS } from "../data/content";
import { fadeUp, staggerContainer, viewportOnce, EYEBROW } from "../lib/motion";

export const Process = () => {
  return (
    <section id="cara-kerja" data-testid="process-section" className="relative bg-graytone-light py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="max-w-3xl"
        >
          <span className={EYEBROW}>Cara Kerja</span>
          <h2 className="mt-5 font-serif text-4xl md:text-5xl tracking-tight text-navy leading-[1.05]">
            5 Langkah Mudah <span className="italic text-gold-dark">Bersama Kami</span>
          </h2>
          <p className="mt-5 text-graytone-dark text-lg">
            Dari konsultasi awal hingga penyelesaian, setiap langkah berjalan transparan, terstruktur, dan sesuai kebutuhan Anda.
          </p>
        </motion.div>

        <motion.div
          variants={staggerContainer}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="relative mt-16 grid md:grid-cols-5 gap-8 md:gap-4"
        >
          {/* connecting line */}
          <div className="hidden md:block absolute top-7 left-[10%] right-[10%] h-px bg-gradient-to-r from-transparent via-gold/50 to-transparent" />
          {PROCESS.map((p) => (
            <motion.div key={p.no} variants={fadeUp} data-testid={`process-step-${p.no}`} className="relative text-center md:text-left">
              <div className="relative z-10 mx-auto md:mx-0 flex items-center justify-center h-14 w-14 rounded-full bg-navy text-gold font-serif text-xl font-semibold shadow-soft ring-4 ring-graytone-light">
                {p.no}
              </div>
              <h3 className="mt-5 font-serif text-2xl text-navy">{p.title}</h3>
              <p className="mt-2 text-sm text-graytone-dark leading-relaxed">{p.body}</p>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
};
